import React, { useCallback, useMemo } from "react";

import { IconProp } from "@fortawesome/fontawesome-svg-core";
import { faCircle } from "@fortawesome/pro-solid-svg-icons/faCircle";
import { faMapMarkerAlt } from "@fortawesome/pro-solid-svg-icons/faMapMarkerAlt";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import cn from "classnames";
import { useIntl } from "react-intl";

import MarkerIcon from "@mapmycustomers/shared/enum/MarkerIcon";

import { AnalyticsService } from "@app/util/analytic/AnalyticsService";

import styles from "./PinStyleCards.module.scss";

interface StyleItem {
  icon: IconProp;
  styleValue: MarkerIcon;
  text: string;
}

interface Props {
  analyticIssuer?: AnalyticsService;
  onChange?: (value: MarkerIcon) => void;
  value?: MarkerIcon;
}

const PinStyleCards: React.FC<Props> = ({ analyticIssuer, onChange, value }) => {
  const intl = useIntl();
  const styleItems: StyleItem[] = useMemo(
    () => [
      {
        icon: faMapMarkerAlt,
        styleValue: MarkerIcon.PIN,
        text: intl.formatMessage({
          id: "settings.mapPreferences.pinStyle.marker",
          defaultMessage: "Pin Marker",
          description: "Title of settings Map Preferences marker pin style",
        }),
      },
      {
        icon: faCircle,
        styleValue: MarkerIcon.CIRCLE,
        text: intl.formatMessage({
          id: "settings.mapPreferences.pinStyle.circle",
          defaultMessage: "Circle",
          description: "Title of settings Map Preferences marker Circle style",
        }),
      },
    ],
    [intl]
  );

  const handleChange = useCallback(
    (styleValue: MarkerIcon) => {
      if (styleValue === MarkerIcon.PIN) {
        analyticIssuer?.clicked(["Pin Marker"]);
      } else {
        analyticIssuer?.clicked(["Circle"]);
      }
      onChange?.(styleValue);
    },
    [analyticIssuer, onChange]
  );

  return (
    <div className={styles.container}>
      {styleItems.map(({ icon, styleValue, text }) => (
        <div key={styleValue} onClick={() => handleChange(styleValue)}>
          <div className={cn(styles.card, { [styles.selected]: styleValue === value })}>
            <FontAwesomeIcon icon={icon} size="2x" />
            <p>{text}</p>
          </div>
        </div>
      ))}
    </div>
  );
};

export default PinStyleCards;
